import React from 'react';
import RiskCardSelected from '../Cards/RiskCardSelected';
import QuotationCardResult from '../../../reusable/QuotationCardResult';
import { SelectQuotePlaceholder } from './v2/ResultSlotCard.styles';

function SelectedQuotesCards({
  processingQuote,
  type,
  requestInfo,
  riskQuotations,
  guaranteesPrima,
}) {
  return (
    <>
      {processingQuote !== null && type.id === 'res_civile' && (
        <div className="col-12 mb-2">
          <QuotationCardResult
            processingQuote={processingQuote}
            requestInfo={requestInfo}
            guaranteesPrima={guaranteesPrima}
          />
        </div>
      )}

      {processingQuote === null && type.id === 'res_civile' && (
        <SelectQuotePlaceholder
          data-bs-toggle="modal"
          data-bs-target={`#${type.id}`}
        >
          Seleziona Quotazione!
        </SelectQuotePlaceholder>
      )}

      {riskQuotations
        && riskQuotations[type.id] !== undefined
        && riskQuotations[type.id].map((quote, idx) => (
          <React.Fragment key={idx}>
            {processingQuote !== null
              && !(type.id === 'res_civile' && processingQuote.company_id === 2)
              && type.id === quote.quote_type && (
                <div className="col-12 mb-2">
                  <RiskCardSelected quote={quote} type={type} requestInfo={requestInfo} />
                </div>
            )}
          </React.Fragment>
        ))}

      {riskQuotations
        && riskQuotations[type.id] === undefined
        && type.id !== 'res_civile'
        && processingQuote !== null && (
          <>

            <SelectQuotePlaceholder
              data-bs-toggle="modal"
              data-bs-target={`#${type.id}`}
            >
              Seleziona Quotazione!
            </SelectQuotePlaceholder>

          </>
      )}
    </>
  );
}

export default SelectedQuotesCards;
